import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Badge from "@mui/material/Badge";
import {useTranslation} from "react-i18next";
import {RightSidebarFloatingPanel} from "../../../layout/rightSidebar/RightSidebarFloatingPanel";
import {RightSidebarPanelButton} from "../../../layout/rightSidebar/RightSidebarRail";
import FilterPanel from "../components/FilterPanel";
import {useServerTableContext} from "../ServerTableContext";
import type {ServerTableFilterProps} from "../types";

export function ServerTableRailFilter({options, disabled}: ServerTableFilterProps) {
    const {t} = useTranslation();
    const {filterRules, setFilterRules} = useServerTableContext();

    return (
        <RightSidebarPanelButton
            icon={(
                <Badge badgeContent={filterRules.length}>
                    <FilterAltOutlinedIcon/>
                </Badge>
            )}
            label={t("Filter")}
            disabled={disabled}
            renderPanel={close => (
                <RightSidebarFloatingPanel>
                    <FilterPanel
                        filterOptions={options}
                        rules={filterRules}
                        onChange={setFilterRules}
                        onClose={close}
                    />
                </RightSidebarFloatingPanel>
            )}
        />
    );
}
